<template>
  <div style="width: 100%; height: 500px;">
    <canvas id="DemandChart"></canvas>
  </div>
</template>

<script setup>
import {onMounted, watch} from 'vue';
import { Chart } from 'chart.js';

const props = defineProps({
  chartData: {
    type: Object,
    default: () => ({
      labels: [],
      datasets: []
    })
  },
  options: {
    type: Object,
    default: () => ({})
  },
  chartType: {
    type: String,
    default: 'line'
  }
})

const renderChart = () => {
  const canvasId = "DemandChart"
  if(Chart.getChart(canvasId)) {
    Chart.getChart(canvasId)?.destroy()
  }
  if (props.chartType) {
    const ctx = document.getElementById(canvasId).getContext('2d');
    new Chart(ctx, {
      type: props.chartType,
      data: props.chartData,
      options: props.options
    });
  }
}

onMounted(() => {
  renderChart()
})

watch(() => props.chartType, (value) => {
  renderChart();
})
</script>